import H from 'highcharts'
//TODO improve handling of highcharts

const convertPointFormat = function (element) {
  if (Array.isArray(element)) {
    //convert point format in case of array
    const [name, y] = element
    element = {name, y}
  }
  return element
}

const reduceLastParition = function (partitions, minSize) {
  if (partitions.length > 1 && minSize > 1) {
    //if last partition is to small add to previous
    const lastPartiton = partitions[partitions.length - 1]
    const prevPartiton = partitions[partitions.length - 2]
    if (lastPartiton.length < minSize) {
      prevPartiton.push(...lastPartiton)
      partitions.splice(-1, 1)
      reduceLastParition(partitions, minSize)
    }
  }
}

const partitionData = function (data, {type, value, minSize = 3}) {
  let result
  if (type === 'count') {
    result = data.reduce((result, element, index) => {
        const key = Math.floor(index / value)
        if (!result[key]) result[key] = []
        result[key].push(element)
        return result
      },
      [])
  } else if (type === 'percent') {
    let partitionTotal = data.reduce((sum, p) => sum + p.y, 0)
    let key = 0
    let partitionVal = 0
    result = data.reduce((result, element, index) => {
        if (!result[key]) result[key] = []
        result[key].push(element)
        partitionVal += element.y

        const nextVal=index+1<data.length?data[index+1].y:null
        const nextUsage = 100 / partitionTotal * nextVal

        if (nextUsage < value) {
          key++
          partitionTotal -= partitionVal
          partitionVal = 0
        }

        return result
      },
      [])
  } else {
    const err = 'autogroup pie cant handle partition.type ' + type
    console.error(err)
    throw new Error(err)
  }

  reduceLastParition(result, minSize)

  return result
}

export default {
  presetEvents: {
    afterMerge(H, options) {
      //TODO improve hand of H object
      const {presetData, series} = options
      if (series.length !== 1 && !presetData.partition) {
        const err = 'autogroup expected exactly one series and partition information'
        console.error(err)
        throw new Error(err)
      }

      if (!options.drilldown) {
        options.drilldown = {}
      }
      if (!options.drilldown.series) {
        options.drilldown.series = []
      }


      //unify data
      series[0].data = series[0].data.map(point => convertPointFormat(point))
      const {data} = series[0]

      if (presetData.freeFloat) {
        const total = data.reduce((sum, p) => sum + p.y, 0)
        const diff = presetData.freeFloat - total
        if (diff > 0) {
          data.push(
            {
              name: "Freier Markt",
              y: diff,
            }
          )
        }
      }

      data.sort((a, b) => b.y - a.y) //sort asc

      const partitions = partitionData(data, presetData.partition)


      let lastGroup = null

      for (let index = partitions.length - 1; index >= 0; index--) {
        const part = partitions[index]

        if (lastGroup) {
          part.push({
            name: lastGroup.name,
            y: lastGroup.sum,
            drilldown: lastGroup.id
          })
        }
        lastGroup={
          name: "Weitere",
          id: "partition_" + index,
          data: part,
          sum: part.reduce((sum, p) => sum + p.y, 0)
        }
        options.drilldown.series.push(
          lastGroup
        )
      }

      options.series[0].data = partitions[0]
    }
  },
  lang: {
    drillUpText: 'Zurück'
  },
  tooltip: {
    valueSuffix: ' %',
    valueDecimals: 2,
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        formatter(){
          const  value = H.numberFormat(this.y, 2)
          return `${this.point.name} ${value} %`
        }
      }
    }
  },
}
